import { Checkbox, Radio } from "antd";
import React, { useEffect, useMemo, useState } from "react";
import EnterContent from "./EnterContent";
const SelectAnswer = ({ type, dataAnswer, setAnswer }) => {
  const [valueRadio, setValueRadio] = useState();
  const [valueCheckbox, setValueCheckbox] = useState([]);
  const [text, setText] = useState("");
  const [error, setError] = useState(true);
  const [content, setContent] = useState("");
  const onChangeRadio = (e) => {
    setValueRadio(e.target.value);
    if (dataAnswer[e.target.value].answer === "Lý do khác") {
      setError(true);
      return setAnswer([{ id: "text", answer: "" }]);
    } else {
      setError(false);
      setAnswer([
        {
          answer: dataAnswer[e.target.value].answer,
        },
      ]);
    }
  };
  const dataCheckbox = useMemo(() => {
    const result = [];
    dataAnswer.map((item) => {
      if (item.status === 1) {
        return result.push(item.content);
      } else return item;
    });
    return result;
  }, [dataAnswer]);
  const onChangeCheckBox = (values) => {
    setValueCheckbox(values);
    let result = [];
    values.map((item) => {
      if (item === "Lý do khác") {
        result.push({
          answer: "",
          id: "text",
        });
      } else {
        result.push({
          answer: item,
        });
      }
    });
    setAnswer(result);
  };
  useEffect(() => {
    const time = setTimeout(() => {
      setAnswer((pre) => {
        const result = pre?.map((item) => {
          if (item.id === "text") {
            return {
              ...item,
              answer: text,
            };
          } else return item;
        });
        return result;
      });
      if (!text) setError(false);
      else setError(true);
    }, 1500);
    return () => clearTimeout(time);
  }, [text]);

  return (
    <div className="wrapperSelectAnswer">
      {type === 1 ? (
        <>
          <Radio.Group value={1}>
            {dataAnswer.map((item, index) => {
              // if (item.status === 1 && item.typeAnswer) {
              //   setContent(item.detailAnswer);
              // } else {
              //   setContent("");
              // }
              // const result = "";
              return (
                <Radio
                  className="itemSelecter"
                  // checked={true}
                  key={index}
                  style={{ cursor: "not-allowed" }}
                  value={item.status}
                >
                  {item.content}
                </Radio>
              );
            })}
          </Radio.Group>
          {dataAnswer.find((item) => item.typeAnswer && item.status) ? (
            <EnterContent value={content} setText={setText} />
          ) : null}
        </>
      ) : (
        <Checkbox.Group disabled onChange={false} value={dataCheckbox}>
          {dataAnswer?.map((item, index) => {
            if (Number(item.typeAnswer) === 1) {
              return (
                <Checkbox
                  className="itemSelecter"
                  key={item.detailAnswer}
                  value={"Lý do khác"}
                >
                  Lý do khác
                </Checkbox>
              );
            } else
              return (
                <Checkbox
                  className="itemSelecter"
                  key={item.content}
                  value={item.content}
                >
                  {item.content}
                </Checkbox>
              );
          })}
          {dataAnswer.find((item) => item.typeAnswer && item.status) ? (
            <EnterContent setText={setText} />
          ) : null}
        </Checkbox.Group>
      )}
    </div>
  );
};

export default SelectAnswer;
